// Select2 Library Loader
// Loads Select2 CSS and JS for enhanced select dropdowns

(function() {
    'use strict';
    
    // Check if Select2 is already loaded
    if (window.jQuery && jQuery.fn.select2) {
        console.log('Select2 already loaded');
        return;
    }
    
    // Select2 CDN URLs
    var SELECT2_CONFIG = {
        cssUrl: 'https://cdn.jsdelivr.net/npm/select2@4.1.0-rc.0/dist/css/select2.min.css',
        jsUrl: 'https://cdn.jsdelivr.net/npm/select2@4.1.0-rc.0/dist/js/select2.min.js'
    };
    
    // Load CSS
    function loadCSS(url) {
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.type = 'text/css';
        link.href = url;
        document.head.appendChild(link);
        console.log('Select2 CSS loaded');
    }
    
    // Load JavaScript
    function loadJS(url, callback) {
        var script = document.createElement('script');
        script.src = url;
        script.onload = function() {
            console.log('Select2 JS loaded successfully');
            if (callback) callback();
        };
        script.onerror = function() {
            console.error('Failed to load Select2 JS:', url);
        };
        document.head.appendChild(script);
    }
    
    // Initialize loading
    function initializeSelect2() {
        // Check if jQuery is available
        if (!window.jQuery) {
            console.warn('jQuery not found. Select2 requires jQuery.');
            return;
        }
        
        // Load CSS first
        loadCSS(SELECT2_CONFIG.cssUrl);
        
        // Load JS
        loadJS(SELECT2_CONFIG.jsUrl, function() {
            // Dispatch event when Select2 is ready
            var event = new CustomEvent('select2Ready', {
                detail: { 
                    message: 'Select2 is ready to use',
                    timestamp: Date.now()
                }
            });
            window.dispatchEvent(event);
        });
    }
    
    // Start loading when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initializeSelect2);
    } else {
        initializeSelect2();
    }
    
    // Provide a way to check if Select2 is ready
    window.waitForSelect2 = function(callback) {
        if (window.jQuery && jQuery.fn.select2) {
            callback();
        } else {
            window.addEventListener('select2Ready', callback, { once: true });
        }
    };
    
})();